import { createAction } from '@reduxjs/toolkit';

export const INVENTORY_UI_ACTION_TYPES = {
  SET_SELECTED_COUNTY: 'SET_SELECTED_COUNTY',
};

export const setSelectedCounty = createAction<string>(INVENTORY_UI_ACTION_TYPES.SET_SELECTED_COUNTY);
